import { Box, Card, CardBody, Flex, Show, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import React from "react";

const items = [
  {
    key: "stake",
    imgUrl: "/assets/institutions/intro/coins.svg",
    text: "Stake previously staked assets again on a different platform.",
  },
  {
    key: "security",
    imgUrl: "/assets/institutions/intro/security.svg",
    text: "Provide additional security to participating protocols, enhancing utility.",
  },
  {
    key: "yield",
    imgUrl: "/assets/institutions/intro/yield.svg",
    text: "Earn more yield by leveraging multiple decentralized applications.",
  },
];

const Intro = () => {
  return (
    <Box maxWidth="1512px" w="100%" px={{ base: 5, md: 20 }} py={20}>
      <Text fontSize={40} fontWeight={500} textAlign="center">
        What is Restaking?
      </Text>
      <Flex
        mt={12}
        flexDir={{ base: "column", md: "row" }}
        justify="space-between"
        alignItems={{ base: "center", md: "stretch" }}
        w="100%"
        gap={{ base: "42px", md: 4 }}
      >
        {items.map((item) => {
          return (
            <Card
              key={item.key}
              maxW={{ base: 320, md: 398 }}
              w={"100%"}
              borderRadius={32}
              overflow="hidden"
            >
              <Show below="md">
                <BaseImage
                  height={180}
                  width={320}
                  src={item.imgUrl}
                  alt={item.key}
                />
              </Show>
              <Show above="md">
                <BaseImage
                  height={180}
                  width={398}
                  src={item.imgUrl}
                  alt={item.key}
                />
              </Show>
              <CardBody p={8}>
                <Text color={"#3F6870"} fontSize={20}>
                  {item.text}
                </Text>
              </CardBody>
            </Card>
          );
        })}
      </Flex>
    </Box>
  );
};

export default Intro;
